// extracted by mini-css-extract-plugin
module.exports = {"centerAlignItems":"Styles_centerAlignItems__1ZO0W","justifyAlignItems":"Styles_justifyAlignItems__37fNP","inputMargin":"Styles_inputMargin__2dn7U"};